module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAATklEQVQ4y2P4jwQ+MAww7wADDNgPPI//D5Dx/8/g4P3/z8AAIgYBj4EZxIO5bGB5QAY0qAYBDxRA/5HDbAB5f0BZC9mdA8cbRHl68JR1APT+19sdJa6zAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA4KzA5OjAwEILqywAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00990_100x100.png
// module id = RsVf
// module chunks = 0